var _rect, _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedalhaTerror2Bloq({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 213,
    height: 260,
    viewBox: "0 0 213 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 213,
    height: 260,
    rx: 8,
    fill: "#ECE6F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M170.182 112.44C170.182 149.683 142.321 168.305 109.206 179.106C107.472 179.656 105.589 179.629 103.873 179.031C70.6786 168.305 42.8175 149.683 42.8175 112.44V60.2984C42.8175 58.3228 43.6562 56.4282 45.149 55.0313C46.6419 53.6344 48.6666 52.8496 50.7778 52.8496C66.6984 52.8496 86.5992 43.9111 100.45 32.589C102.137 31.2408 104.282 30.5 106.5 30.5C108.718 30.5 110.863 31.2408 112.55 32.589C126.48 43.9856 146.302 52.8496 162.222 52.8496C164.333 52.8496 166.358 53.6344 167.851 55.0313C169.344 56.4282 170.182 58.3228 170.182 60.2984V112.44Z",
    fill: "url(#paint0_linear_2034_7290)",
    stroke: "url(#paint1_linear_2034_7290)",
    strokeWidth: 3.91429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M71 84L107.5 64.5L141.5 84V129L107 145L70 127.5L71 84Z",
    fill: "url(#paint2_linear_2034_7290)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M142.5 126.3V84.7L106.5 65.5L70.5 84.7V126.3L106.5 145.5L142.5 126.3ZM66.5 128.7L146.5 82.3L66.5 128.7ZM66.5 82.3L146.5 128.7L66.5 82.3ZM106.5 65.5V145.5V65.5Z",
    fill: "url(#paint3_linear_2034_7290)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M106.5 65.5L142.5 84.7V126.3L106.5 145.5M106.5 65.5L70.5 84.7V126.3L106.5 145.5M106.5 65.5V145.5M66.5 128.7L146.5 82.3M66.5 82.3L146.5 128.7",
    stroke: "#C0C0C0",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5639 202.136V222.5H76.7401L66.3892 207.565H66.2003V222.5H63.1278V202.136H65.9716L76.3324 217.091H76.5213V202.136H79.5639ZM83.8072 222.5V207.227H86.7802V222.5H83.8072ZM84.0856 205.189L86.4123 200.605H89.5444L86.462 205.189H84.0856ZM103.845 207.227L98.3068 222.5H95.125L89.5767 207.227H92.7685L96.6364 218.98H96.7955L100.653 207.227H103.845ZM112.702 222.808C111.197 222.808 109.901 222.487 108.814 221.844C107.734 221.194 106.899 220.283 106.309 219.109C105.725 217.929 105.434 216.547 105.434 214.963C105.434 213.399 105.725 212.02 106.309 210.827C106.899 209.634 107.721 208.702 108.775 208.033C109.835 207.363 111.075 207.028 112.493 207.028C113.355 207.028 114.19 207.171 114.999 207.456C115.808 207.741 116.533 208.188 117.176 208.798C117.819 209.408 118.327 210.2 118.698 211.175C119.069 212.143 119.255 213.319 119.255 214.705V215.759H107.114V213.531H116.341C116.341 212.749 116.182 212.056 115.864 211.453C115.546 210.843 115.098 210.363 114.522 210.011C113.952 209.66 113.282 209.484 112.513 209.484C111.678 209.484 110.949 209.69 110.326 210.101C109.709 210.505 109.232 211.036 108.894 211.692C108.562 212.341 108.397 213.047 108.397 213.81V215.55C108.397 216.571 108.576 217.439 108.934 218.155C109.298 218.871 109.805 219.418 110.455 219.795C111.105 220.167 111.864 220.352 112.732 220.352C113.295 220.352 113.809 220.273 114.273 220.114C114.737 219.948 115.138 219.703 115.476 219.378C115.814 219.053 116.073 218.652 116.252 218.175L119.066 218.682C118.84 219.51 118.436 220.236 117.853 220.859C117.276 221.476 116.55 221.956 115.675 222.301C114.807 222.639 113.816 222.808 112.702 222.808ZM125.526 202.136V222.5H122.553V202.136H125.526ZM136.896 222.5V220.273L143.787 213.134C144.523 212.358 145.129 211.679 145.607 211.095C146.09 210.505 146.452 209.945 146.69 209.415C146.929 208.884 147.048 208.321 147.048 207.724C147.048 207.048 146.889 206.465 146.571 205.974C146.253 205.477 145.819 205.096 145.268 204.831C144.718 204.559 144.098 204.423 143.409 204.423C142.68 204.423 142.044 204.572 141.5 204.871C140.956 205.169 140.539 205.59 140.247 206.134C139.955 206.677 139.81 207.313 139.81 208.043H136.876C136.876 206.803 137.161 205.719 137.732 204.791C138.302 203.863 139.084 203.144 140.078 202.634C141.072 202.116 142.203 201.858 143.469 201.858C144.748 201.858 145.875 202.113 146.849 202.624C147.83 203.127 148.596 203.817 149.146 204.692C149.696 205.56 149.972 206.541 149.972 207.635C149.972 208.391 149.829 209.13 149.544 209.852C149.266 210.575 148.778 211.38 148.082 212.268C147.386 213.15 146.419 214.221 145.179 215.48L141.132 219.716V219.865H150.3V222.5H136.896Z",
    fill: "#C0C0C0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.5 126.61V122.5C93.5 118.92 94.9223 115.486 97.4541 112.954C99.9858 110.422 103.42 109 107 109C110.58 109 114.014 110.422 116.546 112.954C119.078 115.486 120.5 118.92 120.5 122.5V126.61C122.73 126.776 124.18 127.196 125.242 128.258C127 130.014 127 132.844 127 138.5C127 144.156 127 146.986 125.242 148.742C123.486 150.5 120.656 150.5 115 150.5H99C93.344 150.5 90.514 150.5 88.758 148.742C87 146.986 87 144.156 87 138.5C87 132.844 87 130.014 88.758 128.258C89.818 127.196 91.27 126.776 93.5 126.61ZM96.5 122.5C96.5 119.715 97.6062 117.045 99.5754 115.075C101.545 113.106 104.215 112 107 112C109.785 112 112.455 113.106 114.425 115.075C116.394 117.045 117.5 119.715 117.5 122.5V126.508C116.735 126.501 115.901 126.499 115 126.5H99C98.0973 126.499 97.264 126.501 96.5 126.508V122.5ZM107 133C107.398 133 107.779 133.158 108.061 133.439C108.342 133.721 108.5 134.102 108.5 134.5V142.5C108.5 142.898 108.342 143.279 108.061 143.561C107.779 143.842 107.398 144 107 144C106.602 144 106.221 143.842 105.939 143.561C105.658 143.279 105.5 142.898 105.5 142.5V134.5C105.5 134.102 105.658 133.721 105.939 133.439C106.221 133.158 106.602 133 107 133Z",
    fill: "#8E58BF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2034_7290",
    x1: 106.5,
    y1: 30.5,
    x2: 106.5,
    y2: 179.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECE6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECE6F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2034_7290",
    x1: 106.5,
    y1: 30.5,
    x2: 106.5,
    y2: 179.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C0C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2034_7290",
    x1: 105.75,
    y1: 64.5,
    x2: 105.75,
    y2: 145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECE6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECE6F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2034_7290",
    x1: 106.5,
    y1: 65.5,
    x2: 106.5,
    y2: 145.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECE6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECE6F0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedalhaTerror2Bloq);
export default __webpack_public_path__ + "static/media/Medalha_terror_2_bloq.9a1da26f4a8a9b1a71c1d77940cc058d.svg";
export { ForwardRef as ReactComponent };